'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { PropsWithChildren, Suspense } from 'react';
import ProgressBar from './ProgressBar';
import useWindowWidth from 'shared/hooks/useWindowWidth';
import { Container } from 'reactstrap';
import { MdArrowDownward } from 'react-icons/md';

export default function Header({
  headerImage,
  children,
  className,
}: PropsWithChildren<{ headerImage?: string; className?: string }>) {
  const isMobile = (useWindowWidth() ?? 992) < 992;

  const handleScroll = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <header
      className={`${className} position-relative header-container d-flex flex-column`}
      style={
        headerImage
          ? { minHeight: '590px', background: `url('${headerImage}') no-repeat center center/cover fixed`, height: '100vh' }
          : { background: '#455a63', paddingTop: isMobile ? '90px' : '145px' }
      }
    >
      <Suspense>
        <ProgressBar />
      </Suspense>
      {headerImage && (
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundColor: '#455a63', opacity: '65%' }} />
      )}
      {children && (
        <Container className="flex-grow-1 d-flex flex-column justify-content-center z-1 header-text">{children}</Container>
      )}
      {headerImage && (
        <button
          onClick={handleScroll}
          className={`position-absolute z-1 start-50 translate-middle-x bottom-0 border rounded-circle p-1 ${isMobile ? 'mb-5' : 'mb-3'} bg-transparent`}
        >
          <MdArrowDownward size={24} className="text-white" />
        </button>
      )}
    </header>
  );
}
